import React, {useEffect} from 'react';
import {Formik} from 'formik';
import {useSelector} from 'react-redux';
import {TabInterface, useTabStyles} from "../../../components/Tabs/Tabs.utils";
import Loader from "../../../components/Loader/Loader";
import {ReduxState} from "../../../store/types";
import CallScreeningForm from "../../../components/Forms/Extensions/CallScreening/CallScreeningForm";
import {CallScreeningFormType} from "../../../components/Forms/Extensions/CallScreening/CallScreeningForm.utils";
import RestrictedMessageProvider, {ProviderTabName} from "../../AutoAttendants/Details/RestrictedMessageProvider";
import {useSipTrunkCallScreeningFormData} from "../../../hooks/useSipTrunkCallScreeningFormData";

interface CallScreeningTabInterface extends TabInterface {
    showPBX?: boolean;
    forceTooltip?: string;
    extensionNumber?: string;
}

const CallScreeningTab: React.FC<CallScreeningTabInterface> = (
    {
        handleInitDataChange,
        handleSubmitForm,
        handleDirtyChange,
        handleSetSubmitFunc,
        handleSetIsValidFunc,
        showPBX = true,
        forceTooltip,
        extensionNumber

    }) => {
    const classes = useTabStyles();

    const isDataLoading = useSelector(
        (state: ReduxState) =>
            state.sipTrunks.sipTrunkDetails?.callScreeningTab
                ?.isLoading || false,
    );

    const {initFormData, data} = useSipTrunkCallScreeningFormData();

    useEffect(() => {
        if (!isDataLoading && initFormData) {
            handleInitDataChange?.(initFormData);
            handleSubmitForm?.(initFormData);
        }
    }, [isDataLoading, initFormData]);

    return isDataLoading ? (
        <div className={classes.loader}>
            <Loader dataQa="call-screening-loader"/>
        </div>
    ) : (
        <RestrictedMessageProvider tabName={ProviderTabName.CallScreening}>
            <Formik<CallScreeningFormType>
                initialValues={initFormData}
                onSubmit={(form) => handleSubmitForm?.(form)}
                enableReinitialize={true}
                validateOnChange={false}
            >
                {() => {
                    return (
                        <>
                            <CallScreeningForm
                                service={data.serviceValue}
                                mode={data.mode}
                                handleSubmitForm={handleSubmitForm}
                                handleDirtyChange={handleDirtyChange}
                                handleSetSubmitFunc={handleSetSubmitFunc}
                                handleSetIsValidFunc={handleSetIsValidFunc}
                                showPBX={showPBX}
                                forceTooltip={forceTooltip}
                                extensionNumber={extensionNumber}
                            />
                        </>
                    )
                }
                }

            </Formik>
        </RestrictedMessageProvider>

    );
};

export default CallScreeningTab;
